export default {
    fetchSocials: () => new Promise( (resolve, reject) => resolve( [
        {
            name: "email",
            text: "arezina.kristina23@gmail.com",
            icon: "fas fa-envelope",
            url: "mailto:arezina.kristina23@gmail.com"
        },
        {
            name: "github",
            text: "",
            icon: "fab fa-github",
            url: "https://github.com/kristina-arezina"
        },
        {
            name: "medium",
            text: "",
            icon: "fab fa-medium-m",
            url: "https://arezina-kristina23.medium.com/"
        },
        {
            name: "twitter",
            text: "",
            icon: "fab fa-twitter",
            url: "https://twitter.com/ArezinaKristina"
        },
        {
            name: "linkedin",
            text: "",
            icon: "fab fa-linkedin-in",
            url: "https://linkedin.com/in/kristina-arezina-7a0113197"
        }
    ] ) )
}



// WEBPACK FOOTER //
// ./src/api/socials.js